import { useQuery } from '@tanstack/react-query';

import { getCatalogueStaleness } from '~/services/ConnectionSynxisService';

export const catalogueStalenessQueryKey = ['synxis', 'catalogue-staleness'] as const;

export function useCatalogueStaleness() {
  return useQuery({
    queryKey: catalogueStalenessQueryKey,
    queryFn: getCatalogueStaleness,
  });
}
